export const AiImproverLocalStorage = {
  getImprovementsCount: (accountId: string) => `${accountId}_text_improver_improvements_count`,
}
